import { isString, noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { DEPRECATED_isValidURL } from "@circle-react/helpers/urlHelpers/isValidUrl";
import { Button } from "@circle-react-uikit/Button";

export interface ImagePreviewProps {
  onRemove?: () => void | Promise<void>;
  reset: () => void;
  value: string | File;
}

export const ImagePreview = ({
  reset,
  value,
  onRemove = noop,
}: ImagePreviewProps) => {
  let imageURL: string | undefined = undefined;
  if (isString(value)) {
    if (DEPRECATED_isValidURL(value)) {
      imageURL = value;
    }
  } else {
    imageURL = URL.createObjectURL(value);
  }

  const handleRemove = async () => {
    await onRemove();
    reset();
  };

  return (
    <div className="upload-preview">
      <img loading="lazy" src={imageURL} alt={t("og_image")} />
      <div className="upload-preview__actions">
        <Button onClick={handleRemove} variant="secondary">
          {t("remove")}
        </Button>
      </div>
    </div>
  );
};
